module.exports = __webpack_public_path__ + "static/img/box-btn-game.96e02db.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/Pages/BoxingCamp/img/shake/box-btn-game.png
// module id = 485
// module chunks = 0